import React, { Component } from 'react';
import { connect } from 'react-redux';

export default (ChildComponent) => {
  class ComposedComponent extends Component {
    componentDidMount() {
      window.addEventListener('touchstart', this.touchStart);
      window.addEventListener('touchmove', this.preventTouch, { passive: false });
    }

    componentWillUnmount() {
      window.removeEventListener('touchstart', this.touchStart);
      window.removeEventListener('touchmove', this.preventTouch, { passive: false });
    }

    touchStart(e) {
        if (e.touches.length) {
          this.firstClientX = e.touches[0].clientX;
          this.firstClientY = e.touches[0].clientY;
        }
    }

    preventTouch(e) {
      const minValue = 5; // threshold

      if (e.touches && e.touches.length) {
        this.clientX = e.touches[0].clientX - this.firstClientX;
        this.clientY = e.touches[0].clientY - this.firstClientY;
      }

      // Vertical scrolling does not work when you start swiping horizontally.
      if ((Math.abs(this.clientX) > minValue) && (e.touches[0].target.dataset.name === 'mobileGalleryImg')) {
          e.preventDefault();
          e.returnValue = false;
          return false;
      }
      return true;
    }

    render() {
      return <ChildComponent {...this.props} />;
    }
  }
  return connect()(ComposedComponent);
};
